const cce = {
  MICRO_DEPOSIT_NOT_ALLOWED: {
    message: 'Micro depósito não é permitido para sua conta',
    field: 'type',
    code: 'CCE_1'
  },
  MICRO_DEPOSIT_VALUE_NOT_ALLOWED: {
    message: 'Informar o valor do micro depósito não é permitido para sua conta',
    field: 'type',
    code: 'CCE_2'
  },
  DESCRIPTION_ALLOWED_ONLY_FOR_PIX: {
    message: 'Descrição é permitida somente em validações Pix',
    field: 'pix_description',
    code: 'CCE_3'
  },
  INVALID_DESCRIPTION_LENGTH: {
    message: 'Descrição Pix não pode ser maior que 140 caracteres',
    field: 'pix_description',
    code: 'CCE_4'
  },
  INVALID_DESCRIPTION_FORMAT: {
    message: 'Descrição Pix com formato inválido',
    field: 'pix_description',
    code: 'CCE_5'
  },
  BASIC_VALIDATION_NOT_ALLOWED: {
    message: 'Validação básica não é permitida para sua conta',
    field: 'type',
    code: 'CCE_6'
  }
};

module.exports = cce;
